export const CUSTOMER_EXPERIENCE_CENTER_URL = 'https://community.imprivata.com/s/';

export const ROLE_TYPE_ADMIN = 'admin';

export const IMPRIVATA_DOMAIN = 'imprivata.id';

export enum productTags {
  PATIENT_ACCESS = 'patient-secure-identity',
  SSO = 'sso',
}

export const PORTAL_IDLE_TIMEOUT = 15; // in minutes
export const SELF_SERVICE_TIMEOUT = 5; // in minutes
export const IDLE_TIMEOUT_LOGOUT_EVENT = 'idle-timeout-logout';

export enum QueryKey {
  CLIENT_USER_SESSION = 'getClientUserSession',
  AUTHENTICATORS = 'authenticators',
  CONFIG_SETTINGS = 'config-settings',
  AM_PORTAL_CONFIG_SETTINGS = 'am-portal-config-settings',
  CREDENTIALS = 'credentials',
  FIND_IDP_USERS = 'findIdpUsers',
  FIND_USERS = 'findUsers',
  CONSENT_CHECK = 'consent-check',
  LEGAL_DOCUMENTS = 'legalDocuments',
  DIRECTORIES_CONFIG = 'directories-config',
  PASSWORD_EXPIRATION_INFO = 'password-expiration-info',
  PASSWORD_POLICY = 'password-policy',
  PROX_CARD_MAX_NUMBER = 'prox-card-max-number',
  TENANT_INFO = 'tenant-info',
  AUTHENTICATION_STRENGTH = 'authentication-strength',
  APP_INTEGRATION = 'app-integration',
  APP_CONFIG = 'app-config',
  ENDPOINTS = 'endpoints',
  ENDPOINT_INSTALLER_DATA = 'endpoint-installer-data',
  ENDPOINT_INSTALLATION_KEY = 'endpoint-installation-key',
  ENDPOINT_BEHAVIOR = 'endpoint-behavior',
  IDV_CONNECTIONS = 'idv-connections',
  IDV_CONNECTION = 'idv-connection',
  IDV_OIDC_DISCOVERY = 'idv-oidc-discovery',
  GRACE_PERIOD = 'grace-period',
  APP_PROFILES = 'app-profiles',
}

export const FILES_DOWNLOAD_NAMES = {
  USERS_IMPORT_TEMPLATE: 'import-users-template.csv',
  USERS_IMPORT_ERROR_REPORT: 'import-error-report.csv',
  ENDPOINTS_REPORT: 'endpoints-report.csv',
} as const;
